export let OptionType = /*#__PURE__*/function (OptionType) {
  OptionType["CreateNew"] = "createNew";
  OptionType["Existing"] = "existing";
  return OptionType;
}({});
export const newClientText = 'Push as a new client';